import API from './axiosInstance';

const base = (roomId) => `/ems/rooms/${roomId}/configurations`;
const roomBase = (roomId) => `/ems/rooms/${roomId}`;

export const configurationsApi = {
  list:      (roomId)           => API.get(base(roomId)),
  create:    (roomId, data)     => API.post(base(roomId), data),
  update:    (roomId, id, data) => API.put(`${base(roomId)}/${id}`, data),
  remove:    (roomId, id)       => API.delete(`${base(roomId)}/${id}`),
  listUnits: (roomId)           => API.get(`${roomBase(roomId)}/units`),
};
